import type { ExtractedFact, FactRef } from '@karehero/models';

import { NEED } from 'config/onboardingV4/copy';
import {
  DATE_OF_BIRTH_FACT,
  FULL_NAME_FACT,
  GP_FACT,
  HOSPITAL_STAYS_FACT,
  MEDICAL_TOPIC,
  NI_NUMBER_FACT,
  PERSONAL_DETAILS_TOPIC,
  PHONE_NUMBER_FACT,
  PRIMARY_CAREGIVER_TOPIC,
} from 'utils/extractedFacts';
import { isFullNameKnown } from 'utils/fullNameFromFacts';
import type { Copy } from 'utils/person';

// What we would need from them to help, in the order it is listed: each the
// fact that ticks it off once read.

export interface NeedItem {
  fact: FactRef;
  label: Copy;
  /** Known by more than the fact alone being read; omit to tick on the fact. */
  isKnown?: (facts: readonly ExtractedFact[]) => boolean;
}

export const NEED_ITEMS: readonly NeedItem[] = [
  {
    fact: { topicSlug: PERSONAL_DETAILS_TOPIC, factName: FULL_NAME_FACT },
    label: NEED.name,
    isKnown: isFullNameKnown,
  },
  {
    fact: { topicSlug: PERSONAL_DETAILS_TOPIC, factName: DATE_OF_BIRTH_FACT },
    label: NEED.birth,
  },
  {
    fact: { topicSlug: PERSONAL_DETAILS_TOPIC, factName: NI_NUMBER_FACT },
    label: NEED.niNumber,
  },
  { fact: { topicSlug: MEDICAL_TOPIC, factName: GP_FACT }, label: NEED.gp },
  {
    fact: { topicSlug: MEDICAL_TOPIC, factName: HOSPITAL_STAYS_FACT },
    label: NEED.hospital,
  },
  {
    fact: { topicSlug: PRIMARY_CAREGIVER_TOPIC, factName: PHONE_NUMBER_FACT },
    label: NEED.phone,
  },
];
